import constants from '../../../constants/constants';
import ResourceList from '../Resources/ResourceList/ResourceList';
import { Link } from 'react-router-dom';

const StudyGuideList = () => {
	const newCrumb = [<Link key={1} to="/studyGuide-list" className="!text-black font-semibold">Study Guides</Link>];
	const beforeUpload = (file) => {
		const isPDF = file.type === 'application/pdf';
		if (!isPDF) {
			success('error', `${file.name} is not a pdf file`, 'flashSuccess', messageApi);
			return false;
		}

		return true;
	};
	return (
		<ResourceList
			title="STUDY GUIDE LIST"
			fetchUrl="/study-guide-list-admin"
			uploadUrl="/upload-study-guide"
			breadcrumbs={newCrumb}
			resourceType={0}
			uploadSuccessMsg={constants.studyGuide_upload_success}
			uploadErrorMsg={constants.studyGuide_upload_failure}
			selectSuccessMsg={constants.studyGuide_select_success}
			acceptFileType="application/pdf"
			beforeUpload={beforeUpload}
		/>
	);
};

export default StudyGuideList

